var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -9 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0689 20.3224C19.0689 22.7645 20.9865 24.658 23.4543 24.658C24.1518 24.658 24.7494 24.5209 25.4861 24.1739V22.2663C24.8384 22.9147 24.2644 23.1763 23.5297 23.1763C21.8975 23.1763 20.739 21.9928 20.739 20.3102C20.739 18.7152 21.9341 17.4569 23.4543 17.4569C24.2272 17.4569 24.8124 17.7327 25.4861 18.3916V16.485C24.7748 16.1242 24.19 15.9746 23.4925 15.9746C21.0372 15.9746 19.0689 17.9066 19.0689 20.3224ZM14.91 18.3046C14.91 18.7536 15.1954 18.9908 16.168 19.3507C18.0114 20.0251 18.5577 20.6224 18.5577 21.9426C18.5577 23.5508 17.3762 24.6707 15.6923 24.6707C14.459 24.6707 13.5622 24.1851 12.8156 23.0889L13.8626 22.0807C14.2356 22.8022 14.8583 23.189 15.6313 23.189C16.3545 23.189 16.8896 22.6902 16.8896 22.0171C16.8896 21.6682 16.7275 21.3687 16.4036 21.1572C16.2408 21.057 15.9179 20.9081 15.2833 20.684C13.7612 20.1364 13.2393 19.5503 13.2393 18.4057C13.2393 17.046 14.3605 16.0252 15.8306 16.0252C16.7416 16.0252 17.5752 16.3366 18.272 16.9461L17.424 18.0564C17.0019 17.5833 16.6026 17.3836 16.1173 17.3836C15.4188 17.3836 14.91 17.7814 14.91 18.3046ZM10.5846 24.4709H12.2053V16.1625H10.5846V24.4709ZM7.27202 22.4038C6.76294 22.8638 6.10138 23.0644 5.05432 23.0644H4.61938V17.57H5.05432C6.10138 17.57 6.73694 17.7575 7.27202 18.2422C7.83247 18.741 8.16951 19.5146 8.16951 20.3103C8.16951 21.108 7.83247 21.905 7.27202 22.4038ZM5.37884 16.1625H3V24.4706H5.36632C6.62459 24.4706 7.53299 24.174 8.33064 23.5115C9.27852 22.7274 9.83896 21.5452 9.83896 20.3225C9.83896 17.8705 8.00709 16.1625 5.37884 16.1625ZM36.1203 16.1625L38.3357 21.7432L40.5801 16.1625H42.3368L38.7476 24.6841H37.8754L34.3497 16.1625H36.1203ZM43.0697 24.4708H47.6656V23.0642H44.689V20.8215H47.5561V19.4142H44.689V17.5702H47.6656V16.1623H43.0697V24.4708ZM50.3576 19.9874H50.831C51.8662 19.9874 52.4148 19.5377 52.4148 18.7025C52.4148 17.894 51.8662 17.4712 50.8567 17.4712H50.3576V19.9874ZM51.1421 16.1622C53.0109 16.1622 54.0823 17.0597 54.0823 18.6152C54.0823 19.8873 53.4102 20.7225 52.1895 20.9706L54.8052 24.4707H52.8122L50.5691 21.133H50.3576V24.4707H48.7388V16.1622H51.1421Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1585 22.7268C35.4738 20.67 34.8731 17.9376 32.8166 16.6224V16.6224C30.76 15.3072 28.0271 15.9076 26.7117 17.9644V17.9644C25.3967 20.0206 25.9977 22.7539 28.0542 24.0691V24.0691C30.1107 25.3843 32.8434 24.783 34.1585 22.7268Z",
    fill: "url(#paint0_linear_545_4255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_4255",
    x1: 36.5397,
    y1: 19.0034,
    x2: 29.0929,
    y2: 14.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623918,
    stopColor: "#E47E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D36002"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.33e588c94977e9f9b84c65335c597684.svg";
export { ForwardRef as ReactComponent };